import { POST } from '@/api'
import { padZero } from '@/utils/number'
import { splitDate } from '@/utils/date'
import { normalizeTime } from '@/utils/time'

/**
 * 営業時間
 */
export default {
  namespaced: true,
  state: {
    lunch: {
      start: null,
      end: null,
    },
    dinner: {
      start: null,
      end: null,
    },
    isBusinessDay: null,
    busy: false,
  },
  mutations: {
    set(state, { lunch, dinner, isBusinessDay }) {
      state.lunch = lunch
      state.dinner = dinner
      state.isBusinessDay = isBusinessDay
    },
    busy(state, busy) {
      state.busy = !!busy
    },
  },
  getters: {
    isOnly: ({ lunch, dinner }) => !lunch || !dinner,
    typeByTime: ({ lunch, dinner }) => time => {
      time = normalizeTime(time)
      if (!lunch || (dinner && normalizeTime(dinner.start) <= time && time <= normalizeTime(dinner.end)))
        return 'dinner'
      return !dinner || (normalizeTime(lunch.start) <= time && time < normalizeTime(lunch.end)) ? 'lunch' : 'dinner'
    },
    /**
     * 時刻に対するデフォルトの利用時間を返します
     *
     * @param {string} time 時刻
     * @returns {string} デフォルト利用時間
     */
    getUtilizationTime: (state, { typeByTime }, { stores }) => time =>
      stores.current.store.time[`${typeByTime(time)}Utilization`],
  },
  actions: {
    async get(store, date) {
      const { commit, state, rootState } = store
      if (state.busy) return false
      commit('busy', true)

      const { year, month, day } = splitDate(date)
      const currentStore = rootState.stores.current.store
      const { status, message, data } = await POST('/api/web/store/businesshour', {
        storeId: currentStore.id,
        year: `${year}`,
        month: padZero(month),
        day: padZero(day),
      })
      if (status === 200) {
        const { businessHour, isBusinessDay } = data
        commit(
          'set',
          businessHour.reduce(
            (zones, zone) =>
              Object.assign(zones, {
                [['lunch', 'dinner'][zone.timeZone]]: {
                  start: `${zone.startHour}:${zone.startMinute}`,
                  end: `${zone.endHour}:${zone.endMinute}`,
                },
              }),
            { isBusinessDay },
          ),
        )
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
